import {invalidateQueries, q} from "../state/index.ts";
import {ReminderSchedule} from "platformed-client/types";
import {platformedClient} from ".";

export async function get_(): Promise<ReminderSchedule> {
  return await platformedClient.internalRequest("get", "/api/reminder_schedule", {});
}

export async function update(reminderSchedule: ReminderSchedule) {
  await platformedClient.internalRequest("put", "/api/reminder_schedule", {body: reminderSchedule});
  await invalidateQueries([q.reminderSchedule.filter()]);
}
